import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DashboardService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class RedirectTermConditionGuard implements CanActivate {
  constructor(private dashboardService: DashboardService, private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.dashboardService.getRedirect().then((redirect) => {
      if (redirect) {
        this.router.navigate([redirect]);
        return false;
      }
      return true;
    });
  }
}
